// extracted by mini-css-extract-plugin
module.exports = {"modal":"ManageExpenditureModal_modal__1LrRs","content":"ManageExpenditureModal_content__3T6Ka"};